// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import createAvatar from '../utils/createAvatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const { user } = useAuth();
  let win;
  if (typeof window !== 'undefined' && localStorage.getItem('photoURL')) {
    win = localStorage.getItem('photoURL');
  } else {
    win = user.photoURL;
  }

  return (
    <MAvatar
      src={win}
      alt={user.displayName}
      color={user.photoURL ? 'default' : createAvatar(user.displayName).color}
      {...other}
    >
      {createAvatar(user.displayName).name}
    </MAvatar>
  );
}
